import { Divider } from '@chakra-ui/react';
import { COLOR_PICKER_POPOVER_WIDTH } from './ColorPicker.config';

export const ColorPickerDivider = () => <Divider ml='-1rem' w={`${COLOR_PICKER_POPOVER_WIDTH}px`} />;
